module.exports = __webpack_public_path__ + "img/1338254142.57422955.jpg";